import { css } from '@emotion/react';

export const datePickerFieldCalendar = css`
  border: 0;
`;

export const datePickerFieldPopover = css`
  .MuiPopover-paper {
    box-shadow: 0 1px 16px rgba(80, 100, 130, 0.17);
  }
`;
